module.exports = __webpack_public_path__ + "img/share.4668413f.svg";